import React from "react";

import "./BeneficioCard.css";

/**
 * Card reutilizável: o conteúdo e as ações vêm da página, sem modificar
 * as informações de cada benefício.
 */
export default function BeneficioCard({ titulo, children, acoes = [], destaque = false, amplo = false }) {
	return (
		<article
			className={`beneficioCard${destaque ? " beneficioCard--destaque" : ""}${amplo ? " beneficioCard--amplo" : ""}`}
		>
			<div className="beneficioCard-conteudo">
				<h2 className="beneficioCard-titulo">{titulo}</h2>
				<div className="beneficioCard-texto">{children}</div>
				{acoes.length > 0 && (
					<div className="beneficioCard-acoes">
						{acoes.map(({ texto, href, secundario = false }) => (
							<a
								key={`${texto}-${href}`}
								href={href}
								target="_blank"
								rel="noopener noreferrer"
								className={`beneficioCard-acao${secundario ? " beneficioCard-acao--secundaria" : ""}`}
							>
								{texto}
							</a>
						))}
					</div>
				)}
			</div>
		</article>
	);
}
